import React, { useState } from 'react'
import { Table, /* Button */ } from 'react-bootstrap'
import { format } from 'date-fns'
import InfoIconOverlay from '../../../components/InfoIconOverlay'
import ObjectHistoryModal from '../../../components/ObjectHistoryModal'
import AdverseEventHistoryModal from './AdverseEventHistoryModal'

import { parseDateFromServer } from '../../../functions/dateHandling'
import { getFullName } from '../../../functions/userPermissions'

import '../style.css'

const AdverseEventTable = (props) => {
  const {
    name,
    created_date,
    modified_date,
    date_of_onset,
    time_to_onset,
    event_duration_days,
    event_severity,
    event_seriousness,
    event_outcome,
    patient_chart,
    patient_gender,
    site,
    addressed,
    indication_for_treatment,
    adverseEventHistory,
    action_taken,
    deleted,
    // requires_revisions,
    primary_reporter,
    secondary_reporter,
    principal_investigators,
  } = props

   const [showHistoryModal, toggleShowHistoryModal] = useState(false)
   const [nameOfHistoryField, setNameOfHistoryField] = useState(null)
   const [nameOfNestedHistoryField, setNameOfNestedHistoryField] = useState(null)

   const hideHistory = () => {
     toggleShowHistoryModal(false)
     setNameOfHistoryField(null)
     setNameOfNestedHistoryField(null)
   }

  const onsetDate = date_of_onset ?  format(parseDateFromServer(date_of_onset), "MMMM d,  yyyy") : 'N/A'
  const createdDate = created_date ?  format(new Date(created_date), "MMMM d,  yyyy") : 'N/A'
  const modifiedDate = modified_date ?  format(new Date(modified_date), "MMMM d,  yyyy") : 'N/A'

  let siteRegion = 'N/A'
  if (site && site.region) {
    if (site.region === 'default') {
      siteRegion = 'US'
    } else {
      siteRegion = site.region.toUpperCase()
    }
  }


  return (
    <>
      <ObjectHistoryModal
        show={showHistoryModal}
        title={'test'}
        fetchingObjectHistory={false}
        objectHistory={adverseEventHistory}
        nameOfField={nameOfHistoryField}
        nameOfNestedField={nameOfNestedHistoryField}
        handleClose={hideHistory}
      />

      {
        deleted?
        <h3 className="deleted-ae">Deleted Adverse Drug Reaction</h3>
        :
        null
      }

      <Table striped bordered responsive>
        <tbody>
          <tr>
            <td className='strong'>
              Name
            </td>
            <td>
              {name || 'N/A'}
            </td>
            <td>
              <AdverseEventHistoryModal
                column='name'
                objectHistory={ adverseEventHistory }
              />
            </td>
          </tr>

          <tr>
            <td className='strong'>
              Trial Site ID
            </td>
            <td>
              {patient_chart?.trial_site || 'N/A'}
            </td>
            <td>
              <AdverseEventHistoryModal
                column='trial_site'
                subColumn="patient_chart"
                objectHistory={adverseEventHistory}
              />
            </td>
          </tr>

          <tr>
            <td className='strong'>
              Trial Site Name
            </td>
            <td>
              {site?.name || 'N/A'}
            </td>
            <td></td>
          </tr>

          <tr>
            <td className='strong'>
              Patient Number
            </td>
            <td>
              {patient_chart?.patient_identifier || 'N/A'}
            </td>
            <td>
              <AdverseEventHistoryModal
                column='patient_identifier'
                subColumn="patient_chart"
                objectHistory={adverseEventHistory}
              />
            </td>
          </tr>

          <tr>
            <td className='strong'>
              Patient Gender
            </td>
            <td>
              {patient_gender || 'N/A'}
            </td>
            <td>
              <AdverseEventHistoryModal
                column='gender'
                subColumn="patient_chart"
                objectHistory={adverseEventHistory}
              />
            </td>
          </tr>

          <tr>
            <td className='strong'>
              Date of Onset
            </td>
            <td>
              {onsetDate}
            </td>
            <td>
              <AdverseEventHistoryModal
                column='date_of_onset'
                objectHistory={ adverseEventHistory }
              />
            </td>
          </tr>

          <tr>
            <td className='strong'>
              Time to Onset (days)
              <InfoIconOverlay
                text="Time to onset is calculated by taking the date of onset and subtracting the start date of Cefiderocol. If either of these dates are not provided, the field will read 'N/A'."
              />
            </td>
            <td>
              {time_to_onset || 'N/A'}
            </td>
            <td>
              <AdverseEventHistoryModal
                column='time_to_onset'
                objectHistory={adverseEventHistory}
              />
            </td>
          </tr>

          <tr>
            <td className='strong'>
              Indication For Treatment
              <InfoIconOverlay
                text="Indication for treatment displays the reason to start Cefiderocol. If this is not provided, the field will read 'N/A'."
              />
            </td>
            <td>
              {indication_for_treatment || 'N/A'}
            </td>
            <td>
              <AdverseEventHistoryModal
                column='indication_for_treatment'
                objectHistory={adverseEventHistory}
              />
            </td>
          </tr>

          <tr>
            <td className='strong'>
              Event Duration (days)
            </td>
            <td>
              {event_duration_days || 'N/A'}
            </td>
            <td>
              <AdverseEventHistoryModal
                column='event_duration_days'
                objectHistory={adverseEventHistory}
              />
            </td>
          </tr>

          <tr>
            <td className='strong'>
              Event Severity
            </td>
            <td>
              {event_severity || 'N/A'}
            </td>
            <td>
              <AdverseEventHistoryModal
                column='event_severity'
                objectHistory={adverseEventHistory}
              />
            </td>
          </tr>

          <tr>
            <td className='strong'>
              Serious Event?
            </td>
            <td>
              {event_seriousness || "N/A"}
            </td>
            <td>
              <AdverseEventHistoryModal
                column='event_seriousness'
                objectHistory={adverseEventHistory}
              />
            </td>
          </tr>

          <tr>
            <td className='strong'>
              Outcome
            </td>
            <td>
              {event_outcome || 'N/A'}
            </td>
            <td>
              <AdverseEventHistoryModal
                column='event_outcome'
                objectHistory={adverseEventHistory}
              />
            </td>
          </tr>

          <tr>
            <td className='strong'>
              Action Taken
            </td>
            <td>
              {action_taken || 'N/A'}
            </td>
            <td>
              <AdverseEventHistoryModal
                column='action_taken'
                objectHistory={adverseEventHistory}
              />
            </td>
          </tr>

          <tr>
            <td className='strong'>
              Region
            </td>
            <td>
              {siteRegion}
            </td>
            <td>
              <AdverseEventHistoryModal
                column='region'
                subColumn="site"
                objectHistory={adverseEventHistory}
              />
            </td>
          </tr>

          <tr>
            <td className='strong'>
              Primary Reporter
            </td>
            <td>
              {getFullName(primary_reporter)}
            </td>
            <td></td>
          </tr>

          <tr>
            <td className='strong'>
              Secondary Reporter
            </td>
            <td>
              {getFullName(secondary_reporter)}
            </td>
            <td></td>
          </tr>

          <tr>
            <td className='strong'>
              Principal Investigators
            </td>
            <td>
              {Array.isArray(principal_investigators) && principal_investigators.length > 0 ?
                principal_investigators.map(investigator => getFullName(investigator)).join(', ')
              :
              'N/A'
              }
            </td>
            <td></td>
          </tr>

          <tr>
            <td className='strong'>
              Reported On
            </td>
            <td>
              {createdDate}
            </td>
            <td></td>
          </tr>

          <tr>
            <td className='strong'>
              Last Modified
            </td>
            <td>
              {modifiedDate}
            </td>
            <td></td>
          </tr>

          <tr>
            <td className='strong'>
              Receipt Acknowledged?
            </td>
            <td>
              {addressed ? "Yes" : "No"}
            </td>
            <td>
              <AdverseEventHistoryModal
                column='addressed'
                objectHistory={adverseEventHistory}
              />
            </td>
          </tr>

          {/* <tr>
            <td className='strong'>
              Validation Requested?
            </td>
            <td>
              {requires_revisions === true ? "Yes" : "No"}
            </td>
            <td>
              <AdverseEventHistoryModal column='requires_revisions' objectHistory={adverseEventHistory} />
            </td>
          </tr> */}

          {/* <tr>
            <td className='strong'>
              Validation Requests
            </td>
            <td>
              {Array.isArray(props.adverse_event_review_notes) ? 
              `${props.adverse_event_review_notes.length} ${props.adverse_event_review_notes.length === 1 ? 'note' : 'notes'}`
              : 
              "N/A"
              }
            </td>
            <td>
              <Button onClick={props.toggleShowRequiresRevisionsModal}>
                Show Validation Requests
              </Button>
            </td>
          </tr> */}
        </tbody>
      </Table>
    </>
  )
}

export default AdverseEventTable
